<template>
    <div class="app-container">
        <div class="container-fluid p-3" :locale="locale" :dir="isRTL ? 'rtl' : 'ltr'">
            <AppHeader v-if="!isUnAuthorized && !['Login', 'VerifyOtp', 'ForgotPassword'].includes($route.name)"
                class="mb-3" :isSidebarOpen="sidebarOpen" @toggle-sidebar="toggleSidebar" />


            <div :class="!isUnAuthorized && $route.name !== 'Login' ? 'd-flex gap-3' : 'd-flex gap-3 h-100'">
                <SideBar v-if="!isUnAuthorized && !['Login', 'VerifyOtp', 'ForgotPassword'].includes($route.name)"
                    :is-expanded="sidebarOpen" @toggle-sidebar="toggleSidebar" />

                <!-- Only this container should be scrollable -->
                <div class="flex-grow-1 scrollable-container">
                    <div class="router-container">
                        <router-view class="router-view"></router-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import english from './locales/en-US';
import AppHeader from './components/AppHeader.vue';
import SideBar from './components/SideBar.vue';
import { mapState } from 'vuex';
import Hebrew from "./locales/he-IL";
import { request } from "@/Util/Request";
import { getAuthUser, hasRole } from "@/Util/auth";


// Localization setup
const locales = {
    'en-US': english,
    'he-IL': Hebrew
};

Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: 'en-US',
    fallbackLocale: 'en-US',
    silentTranslationWarn: true,
    messages: {
        'en-US': locales['en-US'].messages,
        'he-IL': locales['he-IL'].messages
    },
});

export default {
    name: 'Localization',
    components: {
        AppHeader,
        SideBar,
    },
    data() {
        return {
            sidebarOpen: window.innerWidth > 768,
        };
    },
    mounted() {
        this.$i18n.locale = this.locale;
        if (!_.isEmpty(getAuthUser())) {
            this.checkingAuth();
        }
    },
    computed: {
        ...mapState(['locale', 'user', 'isUnAuthorized', 'isRTL']),
    },
    methods: {
        toggleSidebar() {
            this.sidebarOpen = !this.sidebarOpen;
        },
        async checkingAuth() {
            const adminRole = hasRole('admin');
            try {
                const response = await request({
                    method: 'get',
                    url: adminRole ? `/admin/profile` : `/user/profile`, //`/auth/profile`,
                });
            } catch (error) {
            }
        },
    },
    watch: {
        locale(val) {
            // this.$i18n.locale = val;
        },
    },
};
</script>
<style scoped>
html,
body {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
}

.scrollable-container {
    height: calc(100vh - 130px);
    overflow-y: auto;
    overflow-x: hidden;
}

.router-container {
    height: auto;
    min-height: 100%;
    display: inline;
    flex-direction: column;

}

.router-view {
    flex: 1;
    overflow-y: auto;
}
</style>